import { useState } from 'react';
import {
  announcementTypes,
  DEFAULT_PAGE_SIZE,
  pageSizeOptions,
} from '../../constants';
import useFetchAnnouncements from '../../hooks/useFetchAnnouncements';
import Announcements from '../announcements';
import NewPaginationContainer from '../global-components/new-pagination';
import PageSizeDropdown from '../global-components/pageSizeDropDown';
import './all-announcements.scss';
import AnnouncementFilters from './AnnouncementFilters';

const AllAnnouncements = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [selectedType, setSelectedType] = useState<any>();
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const { data, isLoading } = useFetchAnnouncements({
    page: currentPage,
    type: selectedType,
    search: searchText,
    page_size: pageSize,
  });

  const hasData = !!(data && data?.content?.data.length > 0);

  const handleFilterChange = () => {
    setCurrentPage(1);
    setSearchText(searchText);
    setSelectedType(selectedType);
  };

  return (
    <div className='container-fluid my-5 px-5'>
      <AnnouncementFilters
        search={searchText}
        onChangeSearch={setSearchText}
        typeValue={selectedType}
        onChangeType={setSelectedType}
        types={announcementTypes}
        onClickFilter={handleFilterChange}
      />
      <div className='row'>
        <div className='col-12'>
          <Announcements
            showLoader={isLoading}
            noDataFound={!hasData && !isLoading}
            announcements={data?.content?.data ?? []}
            viewAll={true}
          />
        </div>
        {hasData && (
          <div className='col-12'>
            <div className='ubbe-card pagination-container'>
              <div className='d-flex justify-content-end align-items-center gap-2'>
                <>
                  <PageSizeDropdown
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    currentSize={pageSize}
                    setCurrentPage={setCurrentPage}
                  />
                  {data?.content?.pages > 1 && (
                    <div className='d-flex align-items-center justify-content-end gap-3'>
                      <NewPaginationContainer
                        totalItems={data?.content?.count}
                        totalPages={data?.content?.pages}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  )}{' '}
                </>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllAnnouncements;
